/* E-gifts blog explorer. Read-only catalog requests; links open existing product pages. */
(() => {
  'use strict';
  const ROOT = '[data-eg-blog-explorer]';
  const BATCH = 12;
  const cache = new Map();
  const instances = new WeakMap();
  const blocked = new Set(['dodatkowy-napis','dodatowe-zdjecie-na-tyl-koszulki','dwie-twarze-bokserki','kubek-z-tym-samym-wzorem','koszulka-z-tym-samym-wzorem','poduszka-z-tym-samym-wzorem','nadruk-na-calych-bokserkach-przod-tyl','zapakuj-na-prezent','zdjecie-ai']);
  const escape = v => String(v ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const shuffle = items => {
    const out = [...items];
    for (let i=out.length-1;i>0;i--) { const j=Math.floor(Math.random()*(i+1)); [out[i],out[j]]=[out[j],out[i]]; }
    return out;
  };
  function safeProduct(p) {
    if (!p || !p.handle || blocked.has(p.handle) || p.available !== true || !(Number(p.price)>0)) return false;
    try {
      const url = new URL(p.url, location.origin), image = new URL(p.image, location.origin);
      return url.origin === location.origin && /\/products\/[^/]+/.test(url.pathname) && /^https?:$/.test(image.protocol);
    } catch (_) { return false; }
  }
  function endpoint(handle,page) {
    const prefix = window.Shopify?.routes?.root || '/';
    const url = new URL(`${prefix}collections/${encodeURIComponent(handle)}`,location.origin);
    url.searchParams.set('section_id','egifts-blog-explorer-data');
    url.searchParams.set('page',String(page));
    url.searchParams.set('sort_by',handle==='bestsellery'?'best-selling':'title-ascending');
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id',preview);
    return url;
  }
  function fetchPage(handle,page) {
    const url=endpoint(handle,page), key=url.href;
    if (cache.has(key)) return cache.get(key);
    const request=(async () => {
      const controller=new AbortController(), timer=setTimeout(()=>controller.abort(),12000);
      try {
        const response=await fetch(url.href,{headers:{Accept:'text/html'},credentials:'same-origin',signal:controller.signal});
        if (!response.ok) throw new Error('catalog-http');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const node=doc.querySelector('[data-eg-blog-explorer-data]');
        if (!node) throw new Error('catalog-section');
        const data=JSON.parse(node.textContent);
        if (!Array.isArray(data.products) || data.collection!==handle || Number(data.page)!==page) throw new Error('catalog-shape');
        return {products:data.products.filter(safeProduct),pages:Math.max(1,Math.min(521,Number(data.pages)||1)),currency:data.currency||'PLN'};
      } finally { clearTimeout(timer); }
    })();
    cache.set(key,request);
    request.catch(()=>cache.delete(key));
    return request;
  }
  function stateFor(instance,handle) {
    if (!instance.states.has(handle)) instance.states.set(handle,{pages:null,loaded:new Set(),products:new Map(),currency:'PLN'});
    return instance.states.get(handle);
  }
  async function addPage(state,handle,page) {
    const data=await fetchPage(handle,page);
    state.pages=data.pages; state.currency=data.currency; state.loaded.add(page);
    data.products.forEach(p=>state.products.set(p.handle,p));
  }
  const unseenPages = state => shuffle(Array.from({length:state.pages||1},(_,i)=>i+1).filter(p=>!state.loaded.has(p)));
  function price(p,currency) {
    let text;
    try { text=new Intl.NumberFormat('pl-PL',{style:'currency',currency}).format(Number(p.price)/100); }
    catch (_) { text=(Number(p.price)/100).toFixed(2).replace('.',',')+' '+currency; }
    return (p.price_varies?'Od ':'')+text;
  }
  function card(p,currency) {
    return `<li class="eg-bx-card" data-product-handle="${escape(p.handle)}"><a class="eg-bx-card__link" href="${escape(p.url)}"><div class="eg-bx-card__media"><img src="${escape(p.image)}" alt="${escape(p.title)}" loading="lazy" decoding="async" width="640" height="640"></div><div class="eg-bx-card__body"><h3>${escape(p.title)}</h3><div class="eg-bx-card__bottom"><span class="eg-bx-card__price">${escape(price(p,currency))}</span><span class="eg-bx-card__cta">Zobacz produkt</span></div></div></a></li>`;
  }
  function arrows(instance) {
    const {list,prev,next}=instance;
    prev.disabled=list.scrollLeft<=2;
    next.disabled=list.scrollLeft+list.clientWidth>=list.scrollWidth-3;
  }
  function chooseBatch(state,previous,ordered) {
    const all=[...state.products.values()];
    const fresh=all.filter(p=>!previous.has(p.handle));
    if (ordered) return all.slice(0,BATCH);
    // Keep genuinely new results only; do not fill a short fresh batch with the old cards.
    return shuffle(fresh.length?fresh:all).slice(0,BATCH);
  }
  async function select(instance,choice,renew=false,initial=false) {
    const token=++instance.sequence,handle=choice.dataset.collection,label=choice.dataset.label;
    const state=stateFor(instance,handle);
    instance.shuffle.disabled=true;
    instance.list.setAttribute('aria-busy','true');
    instance.status.textContent=`Szukamy propozycji: ${label.toLowerCase()}…`;
    let partial=false;
    try {
      if (!state.loaded.size) await addPage(state,handle,1);
      if (token!==instance.sequence || !instance.root.isConnected) return;
      // At most three additional pages per interaction. All collections remain browseable by direct links.
      let budget=3;
      if ((handle==='all' || renew) && unseenPages(state).length) {
        try { await addPage(state,handle,unseenPages(state)[0]); } catch (_) { partial=true; }
        budget--;
      }
      while (budget>0 && unseenPages(state).length) {
        if (token!==instance.sequence || !instance.root.isConnected) return;
        const fresh=[...state.products.values()].filter(p=>!instance.previous.has(p.handle));
        if (fresh.length>=BATCH) break;
        try { await addPage(state,handle,unseenPages(state)[0]); } catch (_) { partial=true;break; }
        budget--;
      }
      if (token!==instance.sequence || !instance.root.isConnected) return;
      const ordered=handle==='bestsellery' && !renew;
      const previous=(renew||initial)?instance.previous:new Set();
      const items=chooseBatch(state,previous,ordered);
      const repeated=items.length>0 && items.every(p=>previous.has(p.handle));
      instance.list.innerHTML=items.map(p=>card(p,state.currency)).join('');
      instance.previous=new Set(items.map(p=>p.handle));
      instance.active=choice;
      instance.root.querySelectorAll('[data-eg-bx-choice]').forEach(a=>{
        const active=a===choice;a.classList.toggle('is-active',active);
        if (active)a.setAttribute('aria-current','true');else a.removeAttribute('aria-current');
      });
      instance.link.href=choice.href;
      instance.link.firstChild.textContent=handle==='all'?'Zobacz wszystkie produkty ':'Zobacz całą kolekcję ';
      if (!items.length) instance.status.textContent=`${label}: nie znaleźliśmy dostępnych propozycji. Wybierz inną kategorię lub zobacz całą kolekcję.`;
      else if (repeated) instance.status.textContent=`${label}: to wszystkie propozycje, które udało się teraz znaleźć. Możesz wybrać inną kategorię.`;
      else instance.status.textContent=`${label}. Liczba propozycji: ${items.length}.${partial?' Część katalogu jest chwilowo niedostępna.':''}`;
      instance.list.scrollTo?.({left:0,behavior:'auto'});
      instance.shuffle.disabled=state.products.size<=items.length && state.loaded.size>=state.pages;
      arrows(instance);
    } catch (_) {
      if (token!==instance.sequence) return;
      instance.status.textContent='Nie udało się pobrać propozycji. Kliknij wybraną kategorię ponownie lub otwórz jej kolekcję.';
      instance.link.href=choice.href;
      instance.link.firstChild.textContent=`Otwórz kolekcję: ${label} `;
      instance.shuffle.disabled=false;
    } finally {
      if(token===instance.sequence)instance.list.removeAttribute('aria-busy');
    }
  }
  function init(root) {
    if (instances.has(root)||root.dataset.egBxReady)return;
    root.dataset.egBxReady='true';
    const get=selector=>root.querySelector(selector);
    const list=get('[data-eg-bx-list]'),shuffleButton=get('[data-eg-bx-shuffle]');
    const instance={root,list,shuffle:shuffleButton,prev:get('[data-eg-bx-prev]'),next:get('[data-eg-bx-next]'),status:get('[data-eg-bx-status]'),link:get('[data-eg-bx-collection-link]'),active:get('[data-eg-bx-choice="random"]'),states:new Map(),sequence:0,previous:new Set([...list.querySelectorAll('[data-product-handle]')].map(li=>li.dataset.productHandle))};
    instances.set(root,instance);
    shuffleButton.hidden=false;get('[data-eg-bx-arrows]').hidden=false;
    root.addEventListener('click',event=>{
      const choice=event.target.closest('[data-eg-bx-choice]');
      if (choice && !event.ctrlKey&&!event.metaKey&&!event.shiftKey&&!event.altKey&&event.button===0) {
        event.preventDefault();instance.started=true;instance.observer?.disconnect();
        select(instance,choice,choice===instance.active);return;
      }
      if (event.target.closest('[data-eg-bx-shuffle]')) {instance.started=true;instance.observer?.disconnect();select(instance,instance.active,true);}
      const direction=event.target.closest('[data-eg-bx-next]')?1:event.target.closest('[data-eg-bx-prev]')?-1:0;
      if(direction)list.scrollBy?.({left:direction*Math.max(180,list.clientWidth*.95),behavior:window.matchMedia?.('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    });
    list.addEventListener('scroll',()=>arrows(instance),{passive:true});
    instance.resize=()=>arrows(instance);window.addEventListener('resize',instance.resize,{passive:true});
    const start=()=>{if(instance.started)return;instance.started=true;select(instance,instance.active,false,true);};
    if ('IntersectionObserver'in window) {
      instance.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){instance.observer.disconnect();start();}},{rootMargin:'500px'});
      instance.observer.observe(root);
    } else start();
    arrows(instance);
  }
  function scan(scope) { if(scope.matches?.(ROOT))init(scope);scope.querySelectorAll(ROOT).forEach(init); }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>scan(document),{once:true});else scan(document);
  document.addEventListener('shopify:section:load',event=>scan(event.target));
  document.addEventListener('shopify:section:unload',event=>{
    event.target.querySelectorAll(ROOT).forEach(root=>{const instance=instances.get(root);if(instance){instance.sequence++;instance.observer?.disconnect();window.removeEventListener('resize',instance.resize);}});
  });
})();